import Vue from 'vue'

var events = { mousemove: [] };

Vue.directive('mouse-leave', {
  inserted: (el, binding) => {

    let mouseIn = false;

    var mousemove = ({ x, y }) => {
      const { top, bottom, left, right } = el.getBoundingClientRect();
      var isIn = x >= left && x <= right && y >= top && y <= bottom;
      if (isIn) {
        mouseIn = true;
      } else if (mouseIn) {
        mouseIn = false;
        binding.value(event);
      }
    }

    var added = events.mousemove.filter(f => f.el === el);
    added.forEach(f => window.removeEventListener('mousemove', f.event));
    events.mousemove = [...events.mousemove.filter(f => f.el !== el), { el, event: mousemove }];
    window.addEventListener('mousemove', mousemove);
  },
  unbind: (el, binding) => {
    events.mousemove
      .filter(f => f.el === el)
      .forEach(f => window.removeEventListener('mousemove', f));
    events.mousemove = events.mousemove.filter(f => f.el !== el);
  },
});